import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import { SubscribeForm as PantheonSubscribeForm } from '@minerva-analytics/pantheon';
import { GREEN } from '../../theme';
import { LUCINA_URL, LUCINA_DOMAIN } from '../../constants';

import {
  trackFacebookConversion,
  trackGoogleConversion,
  getPiwikParams,
} from '../../utils';

import { 
  inputTheme,
} from './SubscribeForm.styles';

const SubscribeForm = ({page}) => {

  const piwikParams = typeof window !== `undefined` ? getPiwikParams() : {};

  const requestConfig = {
    url: `${LUCINA_URL}/subscribers/`,
    headers: { 'X-Lucina-Domain': LUCINA_DOMAIN },
    data: piwikParams,
  };

  const onSuccess = () => {
    trackFacebookConversion(
      `CompleteRegistration`,
      `{"content_name": "email-subscription"}`,
    );

    trackGoogleConversion();
  };
  
  return (
    <ThemeProvider theme={inputTheme}>
      <PantheonSubscribeForm 
        font='Roboto, sans-serif' 
        requestConfig={requestConfig}
        inputPlaceholder='Enter email...'
        buttonText='Try it'
        successColor={GREEN}
        failureColor='red'
        successHandler={onSuccess}
        page={page}
      />
    </ThemeProvider>
  );
};

SubscribeForm.propTypes = {
  page: PropTypes.string,
};

export default SubscribeForm;
